import React, { useState, useEffect } from "react";
import { isEmpty, isUndefined } from "../../util/util";
import { getValueByKey } from '../../util/directive-utils'
import $ from 'jquery';
import { observer } from "mobx-react";
import stateStore from "../../store/stateStore";
import rootScope from "../../store/rootScopeStore";
import errMsgService from "../../services/common/errMsgService";
/**
* 
* 
* @param {any} props 
* @param {any} ref 
* @returns 
*/
const IsdSelectBox = observer(React.forwardRef((props, ref) => {

    const [worklists, setWorkLists] = useState({});
    const [beforeFocus, setBeforeFocus] = useState('');
    const [def, setDef] = useState("0");
    const [defaultNum, setDefaultNum] = useState(props.defaultkubunindex);
    const [valueField, setValueField] = useState('code');
    const [labelField, setLabelField] = useState('name');
    let element = ref ? $(ref.current) : null;

    useEffect(() => {
        let kbnList = rootScope.kbnList ? rootScope.kbnList : [];
        if (!Object.keys(kbnList).length) return;
        // 業務区分リストを取得
        let gyomulists = [];
        if (isUndefined(props.kbnvalue)) return;
        gyomulists = typeof props.kbnvalue === 'string' ? [...kbnList[props.kbnvalue]] : Object.values(props.kbnvalue);
        // 未選択有の場合、先頭に空の選択肢を追加
        if (props.isInsertEmpty) {
            gyomulists.unshift({ value: "", name: "" });
        }
        setWorkLists(gyomulists);
        if (props.valueField) setValueField(props.valueField);
        if (props.labelField) setLabelField(props.labelField);
        let def = gyomulists.length && gyomulists[0].value;
        if (!props.isInsertEmpty) {
            // デフォルト値の設定がない場合
            if (stateStore.state[props.name]) {
                // valueの値を設定
                def = stateStore.state[props.name];
            } else if (props.value) {
                def = props.value;
            }
            else if (isEmpty(props.defaultkubunindex) || +(defaultNum) >= gyomulists.length || +(defaultNum) < 0) {
                // デフォルト値を走査
                gyomulists.map((work) => {
                    // キーが設定されている場合
                    if (work.key === '1') {
                        // デフォルト値を保持
                        def = work.value ? work.value : work.code;

                        if (props.dataGrid) {
                            const eventChange = {
                                target: {
                                    name: props.name,
                                    value: def
                                }
                            }
                            props.onChange(eventChange);
                        } else {
                            stateStore.state[props.name] = def;
                        }

                    }
                });
                // デフォルト値の設定がある場合
            } else {
                // デフォルト値を保持
                def = gyomulists[+(defaultNum)].value;
                const eventChange = {};
                eventChange.target = {
                    name: props.name,
                    value: def
                }
                props.onChange(eventChange);

            }
        } else {
            if (stateStore.state[props.name]) {
                // valueの値を設定
                def = props.value;
            }
        }
        // 選択値初期化
        setDef(def);
    }, [rootScope.kbnList, props.kbnvalue, props.value]);

    useEffect(() => {
        // 選択値初期化
        if (props.dataGrid) {
            setDef(props.value);
        }
    }, [props.value]);

    // テキストボックスのチェック処理を模倣
    function invalidSelect(event) {
        if (!props.required) return;
        const requiredElement = element;

        const isInvalid = getValueByKey(props.name, stateStore.state) ? false : true;
        // 必須入力チェック
        if (!!isInvalid) {
            switch (isUndefined(props.isGyomuHidukeDefault) && isUndefined(props.isUnitDefaultDisplay) && isUndefined(props.isCustomerCdAutomaticallyGet)) {
                case true:
                    errMsgService.addMsgLabel("ESYS0090", props);
                    requiredElement.addClass("error-place");
                    return;
                case false:
            }
        }
        // このチェック処理で発生したエラーではない場合、エラーメッセージの削除は実施しない
        // TODO $rootScope
        // if (isNotEmpty($rootScope.errors.errCd) && $rootScope.errors.errCd[props.name] !== "ESYS0090") return;

        // 正常の場合、エラーメッセージを削除する
        errMsgService.delMsgLabel(props);
        requiredElement.removeClass("error-place");
    };

    // フォーカスインした時
    const onFocus = (event) => {
        // nameの値を保持する
        setBeforeFocus(props.id);
    };

    // フォーカスアウト
    const onBlur = (event) => {
        invalidSelect(event);
    };

    // カスタムイベント
    const onInvalid = (event) => {
        if (isEmpty(event.target.value)) return;
        invalidSelect(event);
    }

    const onChange = (event) => {
        setDef(event.target.value);
        stateStore.setState(props.name, event.target.value);
        if (!!props.onChange) {
            props.onChange(event);
        }
    };

    return (
        <>
            <div className="select-box">
                <select data-testid="IsdSelectBox" className={"form-control " + (props.required ? 'require' : '')} value={def} id={props.id} name={props.id} ref={ref} onFocus={onFocus} onBlur={onBlur} onChange={onChange} onInvalid={onInvalid} disabled={props.disabled ? 'disabled' : ''}>
                    {Object.values(worklists).map((data) => {
                        return (
                            <option value={data[valueField]}>{data[labelField]}</option>
                        )
                    })}
                </select>
            </div>
        </>
    );

}))

export default IsdSelectBox;